import { Selector, createSelector } from "@ngxs/store";
import { CourseState, CourseStateModel } from "./course.state";
import { CourseResponse } from "../models/course.model";

export class CourseSelectors {
  @Selector([CourseState])
  static getCourses(state: CourseStateModel): CourseResponse[] {
    return state.courses;
  }

  @Selector()
  static getCoursesMapFiltered(description: string) {
    return createSelector([CourseState], (state) => {
      return this.filterCourseByDescription(state, description);
    });
  }

  @Selector()
  static getCourseDescription(courseId: number) {
    return createSelector([CourseState], (state) => {
      return this.filterCourseById(state, courseId);
    });
  }

  private static filterCourseByDescription(state: any, description: string) {
    let courses = state.course.courses;
    return courses.filter(course =>
      course.courseDescription.toLowerCase().trim().includes(description.toLowerCase().trim())
    );
  }

  private static filterCourseById(state: any, courseId: number) {
    let courses = state.course.courses;
    return courses.find(course => course.courseId === courseId).courseDescription;
  }
}
